<template>
    <div class="no-subscription-wrap">
        <p class="text-intro">You don't have any Subscriptions yet.</p>
        <div class="plan-wrap row">
            <div
                :class="['subscription-plan item wow fadeInUp', {'active': plan.active }]"
                data-wow-delay="0.4s"
                tabindex="0"
                v-for="plan in plans"
                :key="plan.id"
                @click="selectPlan($event, plan)"
            >
                <div class="discount" v-if="plan.subscription_discount">
                    <div class="ammount">{{ plan.subscription_discount }}<span>%</span></div>
                    <div class="text-d">Save</div>
                </div>
                <h4 class="ttl">{{ plan.title }}</h4>
                <h5 class="price">${{ plan.price_per_month }}</h5>
                <p class="text" v-if="plan.description">{{ plan.description }}</p>
                <button class="btn" type="submit" @click="subscribe(plan.id)">subscribe</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SubscriptionPlanSelect",
        props: {
            inner_plans: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                plans: this.inner_plans,
            }
        },
        mounted() {
            this.plans = this.plans.map(plan => ({...plan, active: false}) );
            this.plans[0].active = true;
        },
        computed: {
            selectedPlan() {
                return this.plans.find(plan => !!plan.active);
            }
        },
        methods: {
            selectPlan(event, plan) {
                event.stopPropagation();

                for (let i = 0; i < this.plans.length; i++) {
                    this.plans[i].active = this.plans[i].id === plan.id;
                }
            },
            showLoading() {
                this.$swal.fire({
                    icon: 'info',
                    title: 'Please Wait!',
                    html: 'Your information is being submitted',
                    allowOutsideClick: false,
                    showCancelButton: false,
                    showConfirmButton: false,
                    willOpen: () => {
                        this.$swal.showLoading();
                    }
                });
            },
            subscribe(id) {
                this.showLoading();

                axios.post('/subscription/create', { subscription_id: id })
                     .then(response => {
                         this.$swal.fire({
                             title: `Success!`,
                             text: response.data.message,
                             icon: 'success',
                         });

                         this.$emit('create', response.data.data);
                     })
                     .catch(error => {
                         this.$swal.fire({
                             title: `Can not add your subscription!`,
                             text: error.response.data.message,
                             icon: 'error',
                         });
                     })
            }
        }
    }
</script>

<style scoped lang="less">
    .subscription-plan {
        cursor: pointer;
    }
</style>
